import StateType from './StateType';

export default class CityType {
    code: string;

    name: string;

    description: string;

    stateType: StateType;

    constructor(_code: string,
      _name: string,
      _description: string,
      _stateType: StateType) {
      this.code = _code;
      this.name = _name;
      this.description = _description;
      this.stateType = _stateType;
    }

  static readonly Kurnool = new CityType('Kurnool', 'Kurnool', '', { ...StateType.andraPradesh });

  static readonly anantapur = new CityType('anantapur', 'Anantapur', '', { ...StateType.andraPradesh });

  static readonly chittoor = new CityType('chittoor', 'Chittoor', '', { ...StateType.andraPradesh });

  static readonly guntur = new CityType('guntur', 'Guntur', '', { ...StateType.andraPradesh });

  static readonly eastGodavari = new CityType('eastGodavari', 'East Godavari', '', { ...StateType.andraPradesh });
  
  static readonly krishna = new CityType('krishna', 'Krishna', '', { ...StateType.andraPradesh });

  static readonly nellore = new CityType('nellore', 'Nellore', '', { ...StateType.andraPradesh });

  static readonly srikakulam = new CityType('srikakulam', 'Srikakulam', '', { ...StateType.andraPradesh });
  
  static readonly vizianagaram = new CityType('vizianagaram', 'Vizianagaram', '', { ...StateType.andraPradesh });
  
  static readonly vishakapatnam = new CityType('vishakapatnam', 'Vishakapatnam', '', { ...StateType.andraPradesh });
  
  static readonly cuddapah = new CityType('cuddapah', 'Cuddapah', '', { ...StateType.andraPradesh });

  static readonly hyderabad = new CityType('hyderabad', 'Hyderabad', '', { ...StateType.telangana });

  static readonly updateCity = new CityType('updateCity', 'Update City', '', { ...StateType.updateState });

  static allCities() {
    return [
      CityType.Kurnool,
      CityType.anantapur,
      CityType.chittoor,
      CityType.guntur,
      CityType.eastGodavari,
      CityType.hyderabad,
      CityType.krishna,
      CityType.vishakapatnam,
      CityType.vizianagaram,
      CityType.srikakulam,
      CityType.nellore,
      CityType.cuddapah,
    ];
  }
}
